import { render, staticRenderFns } from "./CourseRatingDashboard.vue?vue&type=template&id=3b5f131e&scoped=true&"
import script from "./CourseRatingDashboard.vue?vue&type=script&lang=js&"
export * from "./CourseRatingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f131e",
  null
  
)

export default component.exports